import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadTrialGroupLaboratoryPersonnels: ITrialGroupLaboratoryPersonnelsLoadActionCreator = () => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD
        }
    },
    LoadTrialGroupLaboratoryPersonnelById: ITrialGroupLaboratoryPersonnelLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID,
            id
        }
    },
    LoadTrialGroupLaboratoryPersonnelByLaboratoryId: ITrialGroupLaboratoryPersonnelLoadByLaboratoryIdActionCreator = (trialGroupLaboratoryId) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID,
            trialGroupLaboratoryId
        }
    },
    LoadSuccess: ITrialGroupLaboratoryPersonnelLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ITrialGroupLaboratoryPersonnelLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveTrialGroupLaboratoryPersonnel: ITrialGroupLaboratoryPersonnelSaveActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE,
            formData
        }
    },
    SaveSuccess: ITrialGroupLaboratoryPersonnelSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ITrialGroupLaboratoryPersonnelSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateTrialGroupLaboratoryPersonnel: ITrialGroupLaboratoryPersonnelCreateActionCreator = (trialGroupLaboratoryId) => {

        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE,
            trialGroupLaboratoryId
        }
    },
    CreateSuccess: ITrialGroupLaboratoryPersonnelCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ITrialGroupLaboratoryPersonnelCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateTrialGroupLaboratoryPersonnel: ITrialGroupLaboratoryPersonnelValidateActionCreator = (formData) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ITrialGroupLaboratoryPersonnelValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ITrialGroupLaboratoryPersonnelValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: ITrialGroupLaboratoryPersonnelClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_CLEAR,
            propertiesToClear
        }
    },

    Filter: ITrialGroupLaboratoryPersonnelFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_TRIALGROUPLABORATORYPERSONNEL_FILTER,
            formFilter
        }
    };



export const
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD = "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID = "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID = "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_SUCCESS = "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_SUCCESS",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_FAILURE = "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_FAILURE",

    ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE = "ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_SUCCESS = "ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_FAILURE = "ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_FAILURE",

    ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE = "ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_SUCCESS = "ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_FAILURE = "ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_FAILURE",

    ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE = "ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_SUCCESS = "ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_SUCCESS",
    ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_FAILURE = "ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_FAILURE",

    ACTION_TRIALGROUPLABORATORYPERSONNEL_CLEAR = "ACTION_TRIALGROUPLABORATORYPERSONNEL_CLEAR",

    ACTION_TRIALGROUPLABORATORYPERSONNEL_FILTER = "ACTION_TRIALGROUPLABORATORYPERSONNEL_FILTER";

export interface ITrialGroupLaboratoryPersonnelsLoadAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD";
}

export interface ITrialGroupLaboratoryPersonnelsLoadActionCreator {
    (): ITrialGroupLaboratoryPersonnelsLoadAction;
}

export interface ITrialGroupLaboratoryPersonnelLoadSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryPersonnel | Dtos.TrialGroupLaboratoryPersonnel[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryPersonnelLoadSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryPersonnel | Dtos.TrialGroupLaboratoryPersonnel[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryPersonnelLoadSuccessAction;
}

export interface ITrialGroupLaboratoryPersonnelLoadFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryPersonnelLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelLoadFailureAction;
}

export interface ITrialGroupLaboratoryPersonnelLoadByIdAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_ID";
    id: number;
}

export interface ITrialGroupLaboratoryPersonnelLoadByIdActionCreator {
    (id: number): ITrialGroupLaboratoryPersonnelLoadByIdAction;
}

export interface ITrialGroupLaboratoryPersonnelLoadByLaboratoryIdAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_LOAD_BY_LABORATORY_ID";
    trialGroupLaboratoryId: number;
}

export interface ITrialGroupLaboratoryPersonnelLoadByLaboratoryIdActionCreator {
    (trialGroupLaboratoryId: number): ITrialGroupLaboratoryPersonnelLoadByLaboratoryIdAction;
}

export interface ITrialGroupLaboratoryPersonnelSaveAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE";
    formData: Dtos.TrialGroupLaboratoryPersonnel;

}

export interface ITrialGroupLaboratoryPersonnelSaveActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryPersonnel
    ): ITrialGroupLaboratoryPersonnelSaveAction;
}

export interface ITrialGroupLaboratoryPersonnelSaveSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryPersonnelSaveSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryPersonnelSaveSuccessAction;
}

export interface ITrialGroupLaboratoryPersonnelSaveFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryPersonnelSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelSaveFailureAction;
}

export interface ITrialGroupLaboratoryPersonnelCreateAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE";
    trialGroupLaboratoryId: number;
}

export interface ITrialGroupLaboratoryPersonnelCreateActionCreator {
    (trialGroupLaboratoryId: number): ITrialGroupLaboratoryPersonnelCreateAction
}

export interface ITrialGroupLaboratoryPersonnelCreateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryPersonnel;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface ITrialGroupLaboratoryPersonnelCreateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryPersonnel,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ITrialGroupLaboratoryPersonnelCreateSuccessAction;
}

export interface ITrialGroupLaboratoryPersonnelCreateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryPersonnelCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelCreateFailureAction;
}

export interface ITrialGroupLaboratoryPersonnelValidateAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE";
    formData: Dtos.TrialGroupLaboratoryPersonnel;

}

export interface ITrialGroupLaboratoryPersonnelValidateActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryPersonnel
    ): ITrialGroupLaboratoryPersonnelValidateAction;
}

export interface ITrialGroupLaboratoryPersonnelValidateSuccessAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_SUCCESS";
    formData: Dtos.TrialGroupLaboratoryPersonnel;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ITrialGroupLaboratoryPersonnelValidateSuccessActionCreator {
    (
        formData: Dtos.TrialGroupLaboratoryPersonnel,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ITrialGroupLaboratoryPersonnelValidateSuccessAction;
}

export interface ITrialGroupLaboratoryPersonnelValidateFailureAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ITrialGroupLaboratoryPersonnelValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ITrialGroupLaboratoryPersonnelValidateFailureAction;
}

export interface ITrialGroupLaboratoryPersonnelClearAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_CLEAR";
    propertiesToClear?: string[];
}

export interface ITrialGroupLaboratoryPersonnelClearActionCreator {
    (propertiesToClear?: string[]): ITrialGroupLaboratoryPersonnelClearAction;
}

export interface ITrialGroupLaboratoryPersonnelFilterActionCreator {
    (formFilter: IFormFilter): ITrialGroupLaboratoryPersonnelFilterAction;
}

export interface ITrialGroupLaboratoryPersonnelFilterAction {
    type: "ACTION_TRIALGROUPLABORATORYPERSONNEL_FILTER";
    formFilter: IFormFilter;
}

export type TrialGroupLaboratoryPersonnelAction =
    ITrialGroupLaboratoryPersonnelsLoadAction |
    ITrialGroupLaboratoryPersonnelLoadByIdAction |
    ITrialGroupLaboratoryPersonnelLoadByLaboratoryIdAction |
    ITrialGroupLaboratoryPersonnelLoadFailureAction |
    ITrialGroupLaboratoryPersonnelLoadSuccessAction |
    ITrialGroupLaboratoryPersonnelSaveAction |
    ITrialGroupLaboratoryPersonnelSaveSuccessAction |
    ITrialGroupLaboratoryPersonnelSaveFailureAction |
    ITrialGroupLaboratoryPersonnelCreateAction |
    ITrialGroupLaboratoryPersonnelCreateSuccessAction |
    ITrialGroupLaboratoryPersonnelCreateFailureAction |
    ITrialGroupLaboratoryPersonnelValidateAction |
    ITrialGroupLaboratoryPersonnelValidateSuccessAction |
    ITrialGroupLaboratoryPersonnelValidateFailureAction |
    ITrialGroupLaboratoryPersonnelClearAction |
    ITrialGroupLaboratoryPersonnelFilterAction;
